<ion-card-content style="width: 100%">
  <ion-card
    class="outline-card action-card"
    *ngFor="let relayRule of relayRules; let i = index"
    style="
      margin-right: auto;
      margin-left: auto;
      min-width: 440px;
      margin-bottom: 30px;
    "
  >
    <!-- Card Header-->
    <ion-list class="no-padding transparent-bg" style="margin-top: 10px">
      <ion-item>
        <ion-label>
          <h3 style="font-weight: 500">Unthread to JSM sync</h3>
        </ion-label>
        <div slot="end" style="display: flex; align-items: center; gap: 8px">
          <ion-text
            style="font-size: 0.85rem; font-weight: 500"
            [color]="relayRule.enabled ? 'dark' : 'medium'"
          >
            {{ relayRule.enabled ? "Enabled" : "Disabled" }}
          </ion-text>
          <ion-toggle
            [(ngModel)]="relayRule.enabled"
            color="success"
            style="padding-right: 0"
          ></ion-toggle>
        </div>
      </ion-item>
    </ion-list>

    <div>
      <!-- When conversation created section -->
      <ion-card-content style="padding-bottom: 0px">
        <div
          class="flexed card-content action-card"
          style="align-items: center; padding: 4px 16px 0 16px"
        >
          <div
            style="
              margin: 0 6px 6px 0;
              font-size: 0.8rem;
              color: var(--ion-color-medium);
            "
          >
            When:
          </div>
          <div class="input-field" style="padding: 6px; margin-right: 6px">
            Conversation
          </div>
          <div class="input-field" style="padding: 6px">Created</div>
        </div>
      </ion-card-content>

      <div class="line"></div>

      <!-- Conditions section -->
      <ion-card-content style="padding-top: 0px; padding-bottom: 0px">
        <div
          style="
            text-align: center;
            font-size: 0.7rem;
            opacity: 0.7;
            margin: 5px 0;
          "
          [hidden]="!relayRule.filters?.size"
        >
          Continue if:
        </div>
        <div style="display: flex; justify-content: center">
          <ion-card
            class="filter-card action-card"
            [hidden]="!relayRule.filters?.size"
          >
            <app-filter-button
              #filterButton
              [options]="filterOptions"
              (didChange)="filtersDidChange($event, i)"
              [selected]="relayRule.filters || emptyFiltersMap"
              [allowNotEqualsOperator]="true"
              [projectId]="projectId ?? undefined"
            ></app-filter-button>
          </ion-card>
        </div>
        <div style="text-align: center" [hidden]="relayRule.filters?.size">
          <a
            (click)="addFilter($event, i)"
            ngxTippy
            data-tippy-content="Add a filter"
          >
            <ion-icon name="filter-outline" class="filter-icon"></ion-icon>
          </a>
        </div>
      </ion-card-content>

      <div class="line"></div>

      <!-- JSM project selection section -->
      <ion-card-content style="padding-top: 0px">
        <div class="card-content action-card">
          <ion-list class="no-padding transparent-bg">
            <ion-item class="box-header-item">
              <ion-badge
                [color]="'tertiary'"
                slot="start"
                style="
                  margin-right: 12px;
                  font-size: 1.2rem;
                  margin-bottom: 10px;
                "
              >
                <ion-icon [name]="'ticket'"></ion-icon>
              </ion-badge>
              <ion-label>
                <h3 style="margin: 0 0 6px 0; font-weight: 500">
                  Select JSM Project
                </h3>
              </ion-label>
            </ion-item>
          </ion-list>

          <ion-chip
            color="select-chip select-outline"
            mode="ios"
            (click)="showChannelSelector(i)"
            style="margin: 10px 16px 16px 16px"
          >
            <ion-label>
              {{
                relayRule.serviceDesk?.projectName ||
                  relayRule.channel?.name ||
                  "Select a JSM project"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-chip>

          <!-- Request Type Selection -->
          <div *ngIf="relayRule.channelId" style="margin-top: 10px">
            <ion-list class="no-padding transparent-bg">
              <ion-item class="box-header-item">
                <ion-badge
                  [color]="'secondary'"
                  slot="start"
                  style="
                    margin-right: 12px;
                    font-size: 1.2rem;
                    margin-bottom: 10px;
                  "
                >
                  <ion-icon [name]="'list'"></ion-icon>
                </ion-badge>
                <ion-label>
                  <h3 style="margin: 0 0 6px 0; font-weight: 500">
                    Default Request Type
                  </h3>
                  <p style="font-size: 0.85rem; color: var(--ion-color-medium)">
                    Fallback when no matching type found by name
                  </p>
                </ion-label>
              </ion-item>
            </ion-list>

            <ion-chip
              *ngIf="!isInitializing"
              [color]="
                requestTypeDisplayByRule.get(i)?.id
                  ? 'select-chip select-outline'
                  : 'warning'
              "
              mode="ios"
              (click)="showRequestTypeSelector(i, $event)"
              style="margin: 10px 16px 16px 16px"
            >
              <ion-label>
                {{
                  requestTypeDisplayByRule.get(i)?.name ||
                    REQUEST_TYPE_NONE_OPTION_LABEL
                }}
                <ion-icon
                  name="caret-down-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-label>
            </ion-chip>
          </div>
        </div>
      </ion-card-content>
    </div>

    <!-- Action Buttons Footer -->
    <div class="footer">
      <ion-button
        color="primary"
        (click)="saveRelayRule(i)"
        [disabled]="isLoading"
        style="margin: 0"
      >
        Save changes
      </ion-button>
      <ion-button
        fill="clear"
        color="medium"
        (click)="cancelEdit(i)"
        *ngIf="hasRelayRules"
        style="margin: 0"
      >
        Cancel
      </ion-button>
      <div style="flex: 1"></div>
      <ion-button
        color="dark"
        fill="clear"
        (click)="deleteRelayRule(i)"
        *ngIf="hasRelayRules"
        style="margin: 0"
      >
        <ion-icon name="trash-outline" slot="start"></ion-icon>
      </ion-button>
    </div>
  </ion-card>

  <!-- Empty State -->
  <div *ngIf="relayRules.length === 0" style="text-align: center; opacity: 0.6">
    <p>No relay rules configured yet.</p>
  </div>

  <!-- Add Another Relay Rule Button -->
  <div style="text-align: center; margin-top: 20px">
    <ion-button fill="outline" class="btn-small" (click)="addRelayRule()">
      <ion-icon name="add-outline" class="padded-icon"></ion-icon>
      Add new sync configuration
    </ion-button>
  </div>
</ion-card-content>
